import { default as Core } from './button';
import Icon from './Icon';
import Label from './Label';

const Button = Object.assign(Core, { Icon, Label });

export default Button;
export { type Props as ButtonProps } from './button';
